<template>
    <div class="BotSelector">
        <v-layout row align-center @click="openSelector" ref="trigger">
            <div class="bot-name mr-1">
                {{ activeBot ? activeBot.name : $f.tc('selectBot') }}
            </div>
            <v-icon color="#fff">mdi-chevron-down</v-icon>
        </v-layout>
        <v-menu :close-on-content-click="false" v-model="show" :position-x="x" :position-y="y" absolute>
            <div class="fci-list">
                <v-layout
                    v-for="bot in botList"
                    :key="bot.code"
                    class="fci-list-item"
                    :class="{active: bot === activeBot}"
                    @click="loadScenario(bot)"
                >
                    {{ bot.name }}
                </v-layout>
            </div>
        </v-menu>
        <BotSelectorDialog ref="BotSelectorDialog"></BotSelectorDialog>
    </div>
</template>

<script>
import BotService from '@/services/bot.service'
import lodash from 'lodash'
import { mapState } from 'vuex'
import BotSelectorDialog from '@/components/BotSelectorDialog'

export default {
    name: 'BotSelector',
    components: { BotSelectorDialog },
    data () {
        return {
            show: false,
            activeBot: null,
            x: 0,
            y: 0
        }
    },
    computed: {
        ...mapState({
            botList: state => state.botList
        })
    },
    mounted () {
        this.getBotList()
    },
    methods: {
        loadScenario (bot) {
            this.show = false
            this.$router.push(`/bots/${bot.code}/scenario`)
        },
        updateBotName () {
            let botCode = this.$route.params.botCode
            if (!botCode || !this.botList) {
                return
            }
            this.activeBot = this.botList.find(item => item.code === botCode)
            if (!this.activeBot) {
                this.$router.push('/access-denied')
            } else {
                this.$store.dispatch(this.$actionTypes.BOT, this.activeBot)
            }
        },
        getBotList () {
            BotService.search().then(
                result => {
                    let botList = lodash.orderBy(result.data, item => item.name.toLowerCase())
                    this.$store.dispatch(this.$actionTypes.BOT_LIST, botList)
                    let botCode = this.$route.params.botCode
                    if (botCode) {
                        this.updateBotName()
                    }
                }
            )
        },
        openSelector () {
            if (this.botList.length > 15) {
                this.$refs.BotSelectorDialog.open(this.botList).then(this.loadScenario)
            } else {
                let rect = this.$refs.trigger.getBoundingClientRect()
                this.show = true
                this.x = rect.x - 5
                this.y = rect.y + rect.height + 4
            }
        }
    },
    watch: {
        $route: 'updateBotName'
    }
}
</script>

<style scoped lang="scss">
.BotSelector {
    padding: 15px;
    border-radius: 5px;
    border: 1px solid transparent;
    cursor: pointer;

    i {
        transition: none;
    }

    &:hover {
        background: rgb(255, 255, 255, 0.9);

        .bot-name, i {
            color: #0052cc !important;
        }
    }
}

.bot-name {
    color: #fff;
    font-size: 20px;
}

.fci-list {
    background: #fff;
    min-width: 200px;

    .fci-list-item {
        padding: 10px;
    }
}
</style>
